

const ValuerAmendBlockText = (props) => {
    const field = props.field;
    const color = props.color;
    const margin = props.margin;

    return(
        <div className="valuer-amend-block-text-field-container">
            <div className="valuer-amend-field-label" style={{color: color, margin: margin}}> {field} </div>
        </div>
    )
}

export default ValuerAmendBlockText